/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { GoSellElements } from "@tap-payments/gosell";
import Axios from "axios";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";

import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

// Cookies functions
import { getCookie, setCookie, erase } from "../Functions/cookieFunction";
import { handleError } from "../Functions/getAlert";
import { buildTapCardDetails } from "../helper/customeObj";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const GoSellElementsTrans = forwardRef((props, ref) => {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  // const [alertMessage, setAlertMessage] = useState({
  //   open: false,
  //   message: "",
  //   alertSuccess: false,
  // });

  const [credToken, setCredToken] = useState("");
  const data = {
    amount: parseFloat(props.inpValue),
    currency: "KWD",
    threeDSecure: true,
    save_card: false,
    description: "Test Description",
    statement_descriptor: "Sample",
    metadata: {
      udf1: "test 1",
      udf2: "test 2",
    },
    reference: {
      transaction: "txn_0001",
      order: "ord_0001",
    },
    receipt: {
      email: false,
      sms: true,
    },
    customer: {
      first_name: appState.loggedIn
        ? appState.profile.name
        : props.name
        ? props.name
        : null,
      email: appState.loggedIn
        ? appState.profile.email
        : props.email
        ? props.email
        : null,
      phone: {
        country_code: "965",
        number: appState.loggedIn
          ? parseFloat(appState.profile.number)
          : props.number
          ? props.number
          : null,
      },
    },
    merchant: {
      id: "",
    },
    source: {
      id: "src_kw.knet",
    },
    post: {
      url: `${window.location.href}`,
    },
    redirect: {
      url: `${window.location.href}`,
    },
  };

  useImperativeHandle(ref, () => ({
    submitRequest() {
      GoSellElements.submit();
    },
  }));

  const callbackFunc = async (response) => {
    if (props.payWithValue == "card") {
      if (props.setTapCardDetails) {
        props.setTapCardDetails(buildTapCardDetails(response));
      }
      props.setTapId(response.id);
      appDispatch({
        type: "payCard",
        payCard: response.id,
      });
    } else {
      setCredToken(response.id);
      props.setSaveCard(false);
      setCookie("cardToken", JSON.stringify(response.id));
    }
  };
  const handleLogout = () => {

    erase("tokenAuth");
    erase("Profile");
    appDispatch({ type: "logout" });

  };

  const getSaveCards = async () => {
    var credToken = getCookie("tokenAuth");
    if (credToken !== "" && credToken !== null) {
      try {
        const newReq = await Axios.get(
          `${process.env.REACT_APP_API_URL}customer/get_card`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("tokenAuth")}`,
            },
          }
        );

        if (newReq.data.success == true) {
          appDispatch({ type: "updatedCardList", cardList: newReq.data.data });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "success",
            message: `${newReq.data.message}`,
          });
        } else {
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          // appDispatch({
          //   type: "SHOW_ALERT",
          //   alertType: "success",
          //   message: `${newReq.data.message}`,
          // });
        }
        // // console.log(cardData)
      } catch (e) {
        handleError(e, appDispatch);
        Promise.reject(e);
        handleLogout()
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    }
  };

  useEffect(() => {
    const getResponse = async () => {
      appDispatch({
        type: "Set_FreezScreen",
        freezScreen: true,
      });
      try {
        const newReq = await Axios.post(
          `${process.env.REACT_APP_API_URL}customer/save_card`,
          {
            card_id: credToken,
          },
          {
            headers: {
              Authorization: `Bearer ${getCookie("tokenAuth")}`,
            },
          }
        );
        if (newReq.data.success == true) {
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "success",
            message: `${newReq.data.message}`,
          });
          appDispatch({
            type: "updatedCardList",
            cardList: newReq.data.data,
          });
          getSaveCards();
        } else {
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          props.setAlertMessage({
            open: true,
            message: newReq.data.message,
            alertSuccess: newReq.data.success,
          });
        }
      } catch (e) {
        Promise.reject(e);
        handleError(e, appDispatch);
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    };
    if (credToken !== "" && credToken !== null && credToken !== undefined) {
      appDispatch({
        type: "Set_FreezScreen",
        freezScreen: true,
      });
      getResponse();
    } else {
      props.setButtonLoading(false);
    }
  }, [credToken]);

  useEffect(() => {
    var link = document.createElement("link");

    // set the attributes for link element
    link.rel = "stylesheet";

    link.type = "text/css";

    link.href = "./Sass/App.scss";

    // Get HTML head element to append
    // link element to it
    document.getElementsByTagName("HEAD")[0].appendChild(link);
  }, []);

  // }

  return (
    <div id="goSellElement" className="App col-12 p-0">
      <div>
        <GoSellElements
          gateway={{
            publicKey:
              props.status == "invoice"
                ? (props.tapkey != null || props.tapKey != undefined) &&
                  props.tapkey
                : props.live
                ? process.env.REACT_APP_TAP_LIVE_KEY_SAVE_CARD
                : process.env.REACT_APP_TAP_TEST_KEY_SAVE_CARD,
            // publicKey: props.status == 'invoice' ? props.tapkey : process.env.REACT_APP_TAP_TEST_KEY_SAVE_CARD,
            // publicKey:  props.status == 'invoice' ? ( props.live ? props.tapkey.live : props.tapkey.test) : 'pk_live_JzAVsLZrjeK7wFcERO1tkSWB',
            language: "en",
            supportedCurrencies: "all",
            supportedPaymentMethods: "all",
            notifications: "msg",
            callback: callbackFunc,
            labels: {
              cardNumber: "Card Number",
              expirationDate: "MM/YY",
              cvv: "CVV",
              cardHolder: "Name on Card",
              actionButton: "Pay",
            },
            style: {
              base: {
                color: "#535353",
                lineHeight: "18px",
                fontFamily: "sans-serif",
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                  color: "rgba(0, 0, 0, 0.26)",
                  fontSize: "15px",
                },
              },
              invalid: {
                color: "red",
                iconColor: "#fa755a ",
              },
            },
          }}
        />

        <p id="msg"></p>
      </div>
    </div>
  );
});
export default GoSellElementsTrans;
